import type { SessionStreamEvent } from 'eve/client'

export function docueAgentTurnFailure(events: readonly SessionStreamEvent[]) {
  for (let index = events.length - 1; index >= 0; index--) {
    const event = events[index]
    if (event?.type === 'turn.settled')
      return event.data.outcome === 'failed'

    if (event?.type === 'turn.started'
      || event?.type === 'delivery.consumed') {
      return false
    }
  }

  return false
}
